const features = [
  {
    icon: 'ri-flashlight-line',
    title: '全网最新 · 实时追踪',
    desc: '51吃瓜视频全天候监测各平台热点动态，娱乐圈爆料、明星八卦、社会事件第一时间同步上线，确保您看到的每一条51吃瓜视频网内容都是最新一手资讯。',
  },
  {
    icon: 'ri-stack-line',
    title: '海量资源 · 每日更新',
    desc: '平台汇聚海量吃瓜视频资源，涵盖娱乐、综艺、明星、网红等多个领域。51吃瓜官网全网最新入口保持每日50+条内容更新节奏，丰富度远超同类平台。',
  },
  {
    icon: 'ri-shield-check-line',
    title: '安全稳定 · 极速访问',
    desc: '51吃瓜网站首页采用多重安全防护技术，保障用户访问稳定性和隐私安全。无论PC端还是移动端，51吃瓜视频APP都能提供流畅快捷的浏览体验。',
  },
];

export default function FeaturesSection() {
  return (
    <section id="features" className="py-12 md:py-16 bg-background-50">
      <div className="w-full px-4 md:px-6 max-w-[1024px] mx-auto">
        <div className="text-center mb-10">
          <h2 className="font-heading text-2xl md:text-3xl text-foreground-950 mb-3">
            平台优势
          </h2>
          <p className="text-foreground-500 text-sm max-w-lg mx-auto">
            为什么选择51吃瓜视频网作为您的吃瓜首选平台
          </p>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-5">
          {features.map((item, i) => (
            <div
              key={i}
              className="bg-background-100 rounded-xl p-6 text-center hover:bg-background-100 transition-colors"
            >
              <div className="w-12 h-12 flex items-center justify-center rounded-xl bg-primary-100 text-primary-600 mx-auto mb-4">
                <i className={`${item.icon} text-xl`}></i>
              </div>
              <h3 className="font-heading text-base text-foreground-900 mb-2">
                {item.title}
              </h3>
              <p className="text-foreground-600 text-sm leading-relaxed">
                {item.desc}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}